<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-dialog v-model="openDialogEmpresasUsuarioAprobar" max-width="490">
        <v-card>
          <v-card-title class="headline">Aprobar Usuario</v-card-title>
          <v-card-text>
            ¿Deseas Aprobar o Rechazar al Usuario? Esta acción no se puede
            deshacer.
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="openDialogEmpresasUsuarioAprobar = false"
              >Salir</v-btn
            >
            <v-btn
              color="red darken-1"
              text
              @click.prevent="aprobarUsuarioEmpresa('RECHAZADO')"
              >Rechazar</v-btn
            >
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click.prevent="aprobarUsuarioEmpresa('APROBADO')"
              >Aprobar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="openDialogEmpresaAprobar" max-width="490">
        <v-card>
          <v-card-title class="headline">Aprobar Empresa</v-card-title>
          <v-card-text>
            ¿Deseas Aprobar o Rechazar a Empresa? Esta acción no se puede
            deshacer.
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="openDialogEmpresaAprobar = false">Salir</v-btn>
            <v-btn
              color="red darken-1"
              text
              @click.prevent="aprobarEmpresa('RECHAZADO')"
              >Rechazar</v-btn
            >
            <v-spacer></v-spacer>

            <v-btn
              color="green darken-1"
              text
              @click.prevent="aprobarEmpresa('APROBADO')"
              >Aprobar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-flex d-flex xs12 class="my-4 px-4" v-if="isAdminManager">
        <v-card class="mx-2" style="width: 100vw">
          <v-card-title>
            <div class="d-flex">
              <div>
                <p class="my-auto">Lista de Empresas</p>
              </div>
              <div>
                <v-btn
                  icon
                  color="success"
                  class="mx-2"
                  @click="getEmpresaList"
                >
                  <v-icon>mdi-reload</v-icon>
                </v-btn>
              </div>
            </div>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="listaEmpresasHeaders"
              :items="getListaEmpresas"
              :loading="fetching"
            >
              <template v-slot:top>
                <div class="d-flex justify-end">
                  <v-checkbox
                    v-model="soloPendientesEmpresas"
                    label="Solo Pendientes de Aprobación"
                  ></v-checkbox>
                </div>
              </template>
              <template v-slot:item.nombres="{ item }">{{
                concatenarNombre(item)
              }}</template>
              <template v-slot:item.estado="{ item }">
                <v-chip
                  :color="
                    item.estado === 'APROBADO'
                      ? 'green lighten-1'
                      : item.estado === 'PENDIENTE'
                      ? 'lime lighten-2'
                      : 'red lighten-1'
                  "
                  dark
                  >{{ item.estado }}</v-chip
                >
              </template>
              <template v-slot:item.fechaCreacion="{ item }">{{
                formatDate(item.fechaCreacion)
              }}</template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  text
                  icon
                  color="blue"
                  :disabled="item.estado !== 'PENDIENTE'"
                  @click="openEmpresaDialog(item)"
                >
                  <v-icon>mdi-account-group</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12 class="my-4 px-4">
        <v-card class="mx-2" style="width: 100vw">
          <v-card-title>
            <v-card-title>
              <div class="d-flex">
                <div>
                  <p class="my-auto">Lista de Usuarios por Empresas</p>
                </div>
                <div>
                  <v-btn
                    icon
                    color="success"
                    class="mx-2"
                    @click="getUsuariosEmpresaList"
                  >
                    <v-icon>mdi-reload</v-icon>
                  </v-btn>
                </div>
              </div>
            </v-card-title>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="getListaEmpresaUsuariosHeaders"
              :items="getListaUsuariosEmpresa"
              :loading="fetching"
              no-data-text="No hay datos"
            >
              <template v-slot:top v-if="isAdminManager">
                <div class="d-flex justify-end">
                  <v-checkbox
                    v-model="soloPendientesEmpresaUsuarios"
                    label="Solo Pendientes de Aprobación"
                  ></v-checkbox>
                </div>
              </template>
              <template v-slot:item.nombres="{ item }">{{
                concatenarNombre(item)
              }}</template>
              <template v-slot:item.estado="{ item }">
                <v-chip
                  :color="
                    item.estado === 'APROBADO'
                      ? 'green lighten-1'
                      : item.estado === 'PENDIENTE'
                      ? 'lime lighten-2'
                      : 'red lighten-1'
                  "
                  dark
                  >{{ item.estado }}</v-chip
                >
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  text
                  icon
                  color="blue"
                  :disabled="item.estado !== 'PENDIENTE'"
                  @click="openUsuarioEmpresaDialog(item)"
                >
                  <v-icon>mdi-account-question</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  data() {
    return {
      listaEmpresasHeaders: [
        { text: 'Empresa', value: 'nombreEmpresa' },
        { text: 'RUC', value: 'ruc' },
        { text: 'Fecha de Creación', value: 'fechaCreacion' },
        { text: 'Sector', value: 'sectorIndustrialNombre.nombre' },
        { text: 'Estado', value: 'estado' },
        {
          text: 'Acción',
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ],
      listaEmpresaUsuariosHeaders: [
        { text: 'Nombre Completo', value: 'nombres', align: 'start' },
        { text: 'Usuario', value: 'usuario' },
        { text: 'Empresa', value: 'empresa.nombreEmpresa' },
        { text: 'Cargo', value: 'cargo' },
        { text: 'Correo', value: 'correo' }
      ],
      AdminListaEmpresaUsuariosHeaders: [
        { text: 'Nombre Completo', value: 'nombres', align: 'start' },
        { text: 'Usuario', value: 'usuario' },
        { text: 'Empresa', value: 'empresa.nombreEmpresa' },
        { text: 'Cargo', value: 'cargo' },
        { text: 'Correo', value: 'correo' },
        { text: 'Estado', value: 'estado', align: 'center' },
        {
          text: 'Acción',
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ],
      listaEmpresas: [],
      listaUsuariosEmpresa: [],
      selectedUsuarioEmpresa: {},
      empresaSeleccionada: {},
      usuarioEmpresaSeleccionado: {},

      openDialogEmpresaAprobar: false,
      openDialogEmpresasUsuarioAprobar: false,

      soloPendientesEmpresaUsuarios: false,
      soloPendientesEmpresas: false
    }
  },
  computed: {
    getListaUsuariosEmpresa() {
      if (this.soloPendientesEmpresaUsuarios) {
        return this.listaUsuariosEmpresa.filter((i) => i.estado === 'PENDIENTE')
      } else {
        return this.listaUsuariosEmpresa
      }
    },

    getListaEmpresas() {
      if (this.soloPendientesEmpresas) {
        console.log(this.listaEmpresas)
        return this.listaEmpresas.filter((i) => i.estado === 'PENDIENTE')
      } else {
        return this.listaEmpresas
      }
    },

    getListaEmpresaUsuariosHeaders() {
      if (this.isAdminManager) return this.AdminListaEmpresaUsuariosHeaders
      return this.listaEmpresaUsuariosHeaders
    },

    ...mapGetters('user', ['fetching', 'getError']),

    ...mapGetters('admin', ['getAdminData', 'isAdminManager'])
  },
  methods: {
    formatDate(date) {
      let options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }
      return `${new Date(date).toLocaleDateString('es-PE', options)} ${new Date(
        date
      ).toLocaleTimeString()}`
    },

    concatenarNombre(item) {
      return (
        item.nombres + ' ' + item.apellidoMaterno + ' ' + item.apellidoPaterno
      )
    },

    openEmpresaDialog(item) {
      this.openDialogEmpresaAprobar = true
      this.empresaSeleccionada = item
      console.log(this.usuarioEmpresaSeleccionado)
    },

    openUsuarioEmpresaDialog(item) {
      this.openDialogEmpresasUsuarioAprobar = true
      this.usuarioEmpresaSeleccionado = item
      console.log(this.usuarioEmpresaSeleccionado)
    },

    async aprobarEmpresa(estado) {
      let idEmpresa = this.empresaSeleccionada._id

      let body = {
        estado,
        idEmpresa
      }

      let response = await this.fetchCambiarEstadoEmpresa(body)
      await this.getEmpresaList()
      this.openDialogEmpresaAprobar = false
    },

    async aprobarUsuarioEmpresa(estado) {
      let idUsuarioEmpresa = this.usuarioEmpresaSeleccionado._id

      let body = {
        estado,
        idUsuarioEmpresa
      }

      let response = await this.fetchCambiarEstadoUsuarioEmpresa(body)
      await this.getUsuariosEmpresaList()
      this.openDialogEmpresasUsuarioAprobar = false
    },

    async getUsuariosEmpresaList() {
      this.listaUsuariosEmpresa = await this.fetchListaUsuariosEmpresa()
    },

    async getEmpresaList() {
      this.listaEmpresas = await this.fetchListaEmpresas()
    },

    ...mapActions('admin', [
      'fetchListaEmpresas',
      'fetchListaUsuariosEmpresa',
      'fetchCambiarEstadoEmpresa',
      'fetchCambiarEstadoUsuarioEmpresa'
    ])
  },
  async mounted() {
    await this.getUsuariosEmpresaList()
    if (this.isAdminManager) await this.getEmpresaList()
  }
}
</script>

<style>
</style>
